import React from 'react';
import View from "react-native-web/dist/exports/View";
export default View;